export const DEFAULT_REAL_FLAGS = {
  is1Real: true,
  is2Real: true,
  is3Real: true,
}

export const getRealFlags = (lastData) => {
  if (!lastData || !lastData.realFlags) {
    return DEFAULT_REAL_FLAGS
  }

  return {
    is1Real: Boolean(lastData.realFlags.is1Real),
    is2Real: Boolean(lastData.realFlags.is2Real),
    is3Real: Boolean(lastData.realFlags.is3Real),
  }
}
